import { render, staticRenderFns } from "./KycForm.vue?vue&type=template&id=1cba9fe8&scoped=true&"
import script from "./KycForm.vue?vue&type=script&lang=js&"
export * from "./KycForm.vue?vue&type=script&lang=js&"
import style0 from "./KycForm.vue?vue&type=style&index=0&id=1cba9fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba9fe8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
